/**
 * Badge intent per target product so OCP and ODP read as distinct colors, and consistently,
 * across the apps table and the app-detail header. Uses Axiom's semantic intents (no custom
 * colors): OCP → information (blue), ODP → warning (amber). Anything unexpected falls back to
 * information rather than an error color.
 */
export function targetProductIntent(product: string): 'information' | 'warning' {
  return product === 'ODP' ? 'warning' : 'information';
}
